import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RootInterface {
    menuToggle: boolean;
    authToken?: string;
    showIntroduction: boolean;
}

const initialState: RootInterface = {
    menuToggle: false,
    showIntroduction: !localStorage.getItem("introductionSlide"),
};

export const rootSlice = createSlice({
    name: "root",
    initialState,
    reducers: {
        menuToggle: (state) => {
            state.menuToggle = !state.menuToggle;

            if (state.menuToggle && document.body.clientWidth <= 1100) {
                document.body.style.overflow = "hidden";
            }
            if (!state.menuToggle && document.body.clientWidth <= 1100) {
                document.body.style.overflow = "auto";
            }
        },
        setAuthToken: (state, action: PayloadAction<string>) => {
            state.authToken = action.payload;
        },
        setShowIntroduction: (state, action: PayloadAction<boolean>) => {
            state.showIntroduction = action.payload;
        },
    },
});

export const { menuToggle, setAuthToken, setShowIntroduction } =
    rootSlice.actions;

export default rootSlice.reducer;

export {
    useGetUserInfoQuery,
    useSetUserLanguageMutation,
    useSetUserCountryMutation,
    useGetTranslationsQuery,
    useLazyGetUserInfoQuery,
    useLogoutMutation,
    useMarkRefurbishedVisitedMutation,
} from "../common/api/user";
